// Bilingual dictionary: English + Hindi
export const DICT = {
  en: {
    appName: "Haryana Smart Panchayat Suite",
    appShort: "HSPS",
    tagline: "Statewide Rural Governance Operating System",
    home: "Home",
    services: "Services",
    track: "Track Application",
    grievance: "File Grievance",
    login: "Sign in",
    logout: "Sign out",
    register: "Register",
    dashboard: "Dashboard",
    panchayats: "Panchayats",
    properties: "Property Assessment",
    tax: "Property Tax",
    certificates: "Certificates",
    grievances: "Grievances",
    birth: "Birth",
    death: "Death",
    marriage: "Marriage",
    email: "Email",
    password: "Password",
    fullName: "Full Name",
    mobile: "Mobile Number",
    role: "Role",
    submit: "Submit",
    cancel: "Cancel",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    search: "Search",
    print: "Print",
    download: "Download",
    welcome: "Welcome",
    citizen: "Citizen",
    officer: "Officer",
    state: "Government of Haryana",
    govOfHaryana: "Govt. of Haryana",
    panchayatiRaj: "Department of Development & Panchayats",
    heroTitle: "Every village. Every household. One unified system.",
    heroSub: "Pay taxes, request certificates, file grievances and engage with your Gram Panchayat — all from one place.",
    ctaPayTax: "Pay Property Tax",
    ctaCertificate: "Apply for Certificate",
    ctaGrievance: "File a Grievance",
    ctaTrack: "Track Application",
    coreServices: "Core Citizen Services",
    coreServicesSub: "Designed for every resident of Haryana — fast, transparent, paperless.",
    propertyTaxDesc: "View demand notice, pay online, get e-receipt instantly.",
    certificateDesc: "Apply for Birth, Death and Marriage certificates with verified QR.",
    grievanceDesc: "Raise complaints with SLA-tracked resolution and live status.",
    villageInfo: "Village Information",
    villageInfoDesc: "Population, infrastructure, schemes and project updates from your Panchayat.",
    totalPanchayats: "Gram Panchayats",
    totalProperties: "Assessed Properties",
    totalDemand: "Total Demand",
    totalCollected: "Collected",
    outstanding: "Outstanding",
    collectionRate: "Collection Rate",
    openGrievances: "Open Grievances",
    inProgress: "In Progress",
    resolved: "Resolved",
    certIssued: "Certificates Issued",
    enterCredentials: "Sign in to your account",
    noAccount: "Don't have an account?",
    haveAccount: "Already have an account?",
    citizenSignIn: "Citizen / Officer Sign In",
    demoAccounts: "Demo credentials",
    fileGrievance: "File a Grievance",
    grievanceSub: "Tell us about an issue and we'll route it to your Panchayat with an SLA.",
    trackTitle: "Track your application",
    trackSub: "Enter the ticket number from your grievance receipt.",
    ticketNo: "Ticket No.",
    status: "Status",
    category: "Category",
    subject: "Subject",
    description: "Description",
    location: "Location",
    newAssessment: "New Assessment",
    newDemand: "Generate Demand",
    collectTax: "Collect Tax",
    issueCertificate: "Issue Certificate",
    panchayat: "Panchayat",
    district: "District",
    block: "Block",
    ward: "Ward",
    owner: "Owner",
    propertyNo: "Property No.",
    assessmentNo: "Assessment No.",
    address: "Address",
    propertyType: "Property Type",
    residential: "Residential",
    commercial: "Commercial",
    industrial: "Industrial",
    mixed: "Mixed-use",
    builtArea: "Built-up Area (sqft)",
    annualRentalValue: "Annual Rental Value (₹)",
    houseTax: "House Tax",
    waterTax: "Water Tax",
    streetLightTax: "Street Light Tax",
    conservancyTax: "Conservancy Tax",
    drainageTax: "Drainage Tax",
    totalAmount: "Total Amount",
    paidAmount: "Paid Amount",
    paymentMode: "Payment Mode",
    cash: "Cash",
    upi: "UPI",
    cheque: "Cheque",
    card: "Card",
    online: "Online",
    receipt: "Receipt",
    receiptNo: "Receipt No.",
    paidAt: "Paid At",
    financialYear: "Financial Year",
    issueDate: "Issue Date",
    certificateNo: "Certificate No.",
    childName: "Child Name",
    dob: "Date of Birth",
    gender: "Gender",
    fatherName: "Father's Name",
    motherName: "Mother's Name",
    placeOfBirth: "Place of Birth",
    deceasedName: "Name of Deceased",
    dod: "Date of Death",
    age: "Age at death",
    placeOfDeath: "Place of Death",
    husbandName: "Husband's Name",
    wifeName: "Wife's Name",
    marriageDate: "Date of Marriage",
    placeOfMarriage: "Place of Marriage",
    open: "Open",
    closed: "Closed",
    in_progress: "In Progress",
    sla: "SLA",
    days: "days",
    actions: "Actions",
    view: "View",
    pay: "Pay",
    pending: "Pending",
    partial: "Partial",
    paid: "Paid",
    pickPanchayat: "Select Panchayat",
    population: "Population",
    households: "Households",
    sarpanch: "Sarpanch",
    secretary: "Secretary",
    male: "Male",
    female: "Female",
    other: "Other",
    digitalSignature: "Digitally signed by Department of Development & Panchayats, Haryana",
    approvals: "Approvals",
    gisMap: "GIS Map",
    reports: "Reports",
    cashBook: "Cash Book",
    pendingApproval: "Pending Approval",
    aadhaarVerify: "Verify Aadhaar (Demo)",
    aadhaarLast4: "Last 4 digits of Aadhaar",
    enterOtp: "Enter OTP",
    sendOtp: "Send OTP",
    verify: "Verify",
    digiLocker: "Pull from DigiLocker (Demo)",
    pppLookup: "PPP Family Lookup (Demo)",
    downloadPdf: "Download PDF",
    amount: "Amount",
    taxEngine: "Tax Engine",
    gramSabha: "Gram Sabha",
    planning: "GPDP Planning",
    assetMgmt: "Asset Management",
    stakeholders: "Contractors / Vendors",
    accounting: "Accounting",
    audit: "Audit",
    otherTax: "Other Tax",
    notices: "Notices",
    resolutionBook: "Resolution Book",
    rozmel: "Rozmel / Cash Book",
    villageAreas: "Village Area Master",
    userMgmt: "User Management",
    settings: "Settings",
    assessment: "Assessment",
    taxReceipt: "Tax Receipt",
    demand: "Demand",
    fy: "Financial Year",
    village: "Village / Gram Panchayat",
    mode: "Mode",
    gpMode: "Gram Panchayat",
    jskMode: "Jan Seva Kendra",
    sendSms: "Send SMS",
    changePassword: "Change Password",
    backup: "Backup",
    masterSettings: "Master Settings",
  },
  hi: {
    appName: "हरियाणा स्मार्ट पंचायत सूट",
    appShort: "एचएसपीएस",
    tagline: "राज्यव्यापी ग्रामीण शासन प्रचालन प्रणाली",
    home: "मुख्य",
    services: "सेवाएँ",
    track: "आवेदन ट्रैक करें",
    grievance: "शिकायत दर्ज करें",
    login: "लॉगिन",
    logout: "लॉगआउट",
    register: "पंजीकरण",
    dashboard: "डैशबोर्ड",
    panchayats: "पंचायतें",
    properties: "संपत्ति आकलन",
    tax: "संपत्ति कर",
    certificates: "प्रमाणपत्र",
    grievances: "शिकायतें",
    birth: "जन्म",
    death: "मृत्यु",
    marriage: "विवाह",
    email: "ईमेल",
    password: "पासवर्ड",
    fullName: "पूरा नाम",
    mobile: "मोबाइल नंबर",
    role: "भूमिका",
    submit: "जमा करें",
    cancel: "रद्द करें",
    save: "सहेजें",
    edit: "संपादित करें",
    delete: "हटाएँ",
    search: "खोजें",
    print: "प्रिंट करें",
    download: "डाउनलोड",
    welcome: "स्वागत है",
    citizen: "नागरिक",
    officer: "अधिकारी",
    state: "हरियाणा सरकार",
    govOfHaryana: "हरियाणा सरकार",
    panchayatiRaj: "विकास एवं पंचायत विभाग",
    heroTitle: "हर गाँव। हर परिवार। एक एकीकृत प्रणाली।",
    heroSub: "कर भुगतान, प्रमाणपत्र, शिकायत और ग्राम पंचायत की सेवाएँ — सब एक जगह।",
    ctaPayTax: "संपत्ति कर भरें",
    ctaCertificate: "प्रमाणपत्र हेतु आवेदन",
    ctaGrievance: "शिकायत दर्ज करें",
    ctaTrack: "आवेदन ट्रैक करें",
    coreServices: "मूल नागरिक सेवाएँ",
    coreServicesSub: "हरियाणा के हर निवासी के लिए — तेज़, पारदर्शी, कागज़-रहित।",
    propertyTaxDesc: "मांग नोटिस देखें, ऑनलाइन भुगतान करें, तुरंत ई-रसीद पाएं।",
    certificateDesc: "जन्म, मृत्यु एवं विवाह प्रमाणपत्र QR सत्यापन के साथ।",
    grievanceDesc: "SLA-ट्रैक्ड समाधान के साथ शिकायत दर्ज और स्थिति देखें।",
    villageInfo: "गाँव की जानकारी",
    villageInfoDesc: "जनसंख्या, अधोसंरचना, योजनाएँ और परियोजना की प्रगति।",
    totalPanchayats: "ग्राम पंचायतें",
    totalProperties: "मूल्यांकित संपत्तियाँ",
    totalDemand: "कुल मांग",
    totalCollected: "वसूली",
    outstanding: "बकाया",
    collectionRate: "वसूली दर",
    openGrievances: "खुली शिकायतें",
    inProgress: "प्रगति पर",
    resolved: "हल",
    certIssued: "जारी प्रमाणपत्र",
    enterCredentials: "अपने खाते में साइन इन करें",
    noAccount: "खाता नहीं है?",
    haveAccount: "पहले से खाता है?",
    citizenSignIn: "नागरिक / अधिकारी साइन इन",
    demoAccounts: "डेमो क्रेडेंशियल्स",
    fileGrievance: "शिकायत दर्ज करें",
    grievanceSub: "हमें समस्या बताएं — हम इसे SLA सहित पंचायत को भेजेंगे।",
    trackTitle: "अपना आवेदन ट्रैक करें",
    trackSub: "अपनी रसीद से टिकट संख्या दर्ज करें।",
    ticketNo: "टिकट संख्या",
    status: "स्थिति",
    category: "श्रेणी",
    subject: "विषय",
    description: "विवरण",
    location: "स्थान",
    newAssessment: "नया आकलन",
    newDemand: "मांग जारी करें",
    collectTax: "कर संग्रह",
    issueCertificate: "प्रमाणपत्र जारी करें",
    panchayat: "पंचायत",
    district: "ज़िला",
    block: "खंड",
    ward: "वार्ड",
    owner: "मालिक",
    propertyNo: "संपत्ति क्रमांक",
    assessmentNo: "आकलन क्रमांक",
    address: "पता",
    propertyType: "संपत्ति प्रकार",
    residential: "आवासीय",
    commercial: "व्यावसायिक",
    industrial: "औद्योगिक",
    mixed: "मिश्रित",
    builtArea: "निर्मित क्षेत्र (वर्ग फुट)",
    annualRentalValue: "वार्षिक किराया मूल्य (₹)",
    houseTax: "गृह कर",
    waterTax: "जल कर",
    streetLightTax: "स्ट्रीट लाइट कर",
    conservancyTax: "स्वच्छता कर",
    drainageTax: "जल निकासी कर",
    totalAmount: "कुल राशि",
    paidAmount: "भुगतान राशि",
    paymentMode: "भुगतान का तरीका",
    cash: "नकद",
    upi: "यूपीआई",
    cheque: "चेक",
    card: "कार्ड",
    online: "ऑनलाइन",
    receipt: "रसीद",
    receiptNo: "रसीद संख्या",
    paidAt: "भुगतान दिनांक",
    financialYear: "वित्तीय वर्ष",
    issueDate: "जारी दिनांक",
    certificateNo: "प्रमाणपत्र क्रमांक",
    childName: "बच्चे का नाम",
    dob: "जन्म दिनांक",
    gender: "लिंग",
    fatherName: "पिता का नाम",
    motherName: "माता का नाम",
    placeOfBirth: "जन्म स्थान",
    deceasedName: "मृतक का नाम",
    dod: "मृत्यु दिनांक",
    age: "मृत्यु पर आयु",
    placeOfDeath: "मृत्यु स्थान",
    husbandName: "पति का नाम",
    wifeName: "पत्नी का नाम",
    marriageDate: "विवाह तिथि",
    placeOfMarriage: "विवाह स्थान",
    open: "खुली",
    closed: "बंद",
    in_progress: "प्रगति पर",
    sla: "SLA",
    days: "दिन",
    actions: "क्रिया",
    view: "देखें",
    pay: "भुगतान",
    pending: "लंबित",
    partial: "आंशिक",
    paid: "भुगतान किया",
    pickPanchayat: "पंचायत चुनें",
    population: "जनसंख्या",
    households: "परिवार",
    sarpanch: "सरपंच",
    secretary: "सचिव",
    male: "पुरुष",
    female: "महिला",
    other: "अन्य",
    digitalSignature: "विकास एवं पंचायत विभाग, हरियाणा द्वारा डिजिटल हस्ताक्षरित",
    approvals: "अनुमोदन",
    gisMap: "जीआईएस मानचित्र",
    reports: "रिपोर्ट",
    cashBook: "रोकड़ बही",
    pendingApproval: "अनुमोदन लंबित",
    aadhaarVerify: "आधार सत्यापित करें (डेमो)",
    aadhaarLast4: "आधार के अंतिम 4 अंक",
    enterOtp: "ओटीपी दर्ज करें",
    sendOtp: "ओटीपी भेजें",
    verify: "सत्यापित करें",
    digiLocker: "डिजिलॉकर से लें (डेमो)",
    pppLookup: "पीपीपी परिवार खोज (डेमो)",
    downloadPdf: "पीडीएफ डाउनलोड",
    amount: "राशि",
    taxEngine: "कर इंजन",
    gramSabha: "ग्राम सभा",
    planning: "जीपीडीपी योजना",
    assetMgmt: "संपत्ति प्रबंधन",
    stakeholders: "ठेकेदार / विक्रेता",
    accounting: "लेखा",
    audit: "लेखा परीक्षा",
    otherTax: "अन्य कर",
    notices: "सूचनाएँ",
    resolutionBook: "ठराव पुस्तक",
    rozmel: "रोजमेल / रोकड़ बही",
    villageAreas: "गाँव क्षेत्र मास्टर",
    userMgmt: "उपयोगकर्ता प्रबंधन",
    settings: "सेटिंग्स",
    assessment: "आकलन",
    taxReceipt: "कर रसीद",
    demand: "मांग",
    fy: "वित्तीय वर्ष",
    village: "ग्राम / पंचायत",
    mode: "मोड",
    gpMode: "ग्राम पंचायत",
    jskMode: "जन सेवा केंद्र",
    sendSms: "एसएमएस भेजें",
    changePassword: "पासवर्ड बदलें",
    backup: "बैकअप",
    masterSettings: "मास्टर सेटिंग्स",
  },
  hr: {
    appName: "हरियाणा स्मार्ट पंचायत सूट",
    appShort: "एचएसपीएस",
    tagline: "सारे हरियाणा का गांव-शासन सिस्टम",
    home: "घर",
    services: "सेवा",
    track: "अर्जी का हाल",
    grievance: "शिकायत दर्ज करो",
    login: "लोग-इन",
    logout: "लोग-आउट",
    register: "नांव लिखवाओ",
    dashboard: "डैशबोर्ड",
    panchayats: "पंचायतां",
    properties: "जायदाद आकलन",
    tax: "जायदाद कर",
    certificates: "प्रमाणपत्र",
    grievances: "शिकायतां",
    birth: "जन्म",
    death: "मरना",
    marriage: "ब्याह",
    email: "ईमेल",
    password: "पासवर्ड",
    fullName: "पूरा नांव",
    mobile: "मोबाइल नंबर",
    role: "भूमिका",
    submit: "जमा करो",
    cancel: "रद्द करो",
    save: "सम्हाल लो",
    edit: "बदलो",
    delete: "मिटाओ",
    search: "ढूंढो",
    print: "छाप",
    download: "उतारो",
    welcome: "स्वागत है",
    citizen: "नागरिक",
    officer: "अधिकारी",
    state: "हरियाणा सरकार",
    govOfHaryana: "हरियाणा सरकार",
    panchayatiRaj: "विकास अर पंचायत विभाग",
    heroTitle: "हर गाम। हर घर। एक सिस्टम।",
    heroSub: "कर भरो, परमान-पत्र लो, शिकायत दर्ज करो — सब एक जगह।",
    ctaPayTax: "जायदाद कर भरो",
    ctaCertificate: "परमान-पत्र मांगो",
    ctaGrievance: "शिकायत दर्ज करो",
    ctaTrack: "अर्जी का हाल जानो",
    coreServices: "मूल नागरिक सेवा",
    coreServicesSub: "हरियाणा के हर बासी ताईं — झट्ट, साफ-सुथरा, कागज़ बिना।",
    propertyTaxDesc: "मांग देखो, ऑनलाइन भरो, झट्ट ई-रसीद पाओ।",
    certificateDesc: "जन्म, मरण अर ब्याह के परमान-पत्र क्यूआर वाले।",
    grievanceDesc: "टाइम सीमा के साथ शिकायत दर्ज करो अर हाल देखो।",
    villageInfo: "गांव की जानकारी",
    villageInfoDesc: "जनसंख्या, ढांचा, योजनां अर परियोजना अपडेट।",
    totalPanchayats: "ग्राम पंचायतां",
    totalProperties: "आकलित जायदादां",
    totalDemand: "कुल मांग",
    totalCollected: "वसूली",
    outstanding: "बकाया",
    collectionRate: "वसूली दर",
    openGrievances: "खुली शिकायतां",
    inProgress: "चालू",
    resolved: "निपटी",
    certIssued: "जारी परमान-पत्र",
    enterCredentials: "अपणे खाते में लोग-इन करो",
    noAccount: "खाता ना है?",
    haveAccount: "पहलां सूं खाता है?",
    citizenSignIn: "नागरिक / अधिकारी लोग-इन",
    demoAccounts: "डेमो खाता",
    fileGrievance: "शिकायत दर्ज करो",
    grievanceSub: "हमनै बताओ, हम पंचायत ताईं टाइम सीमा के साथ भेजांगे।",
    trackTitle: "अपणी अर्जी का हाल देखो",
    trackSub: "रसीद सूं टिकट नंबर डालो।",
    ticketNo: "टिकट नं.",
    status: "हाल",
    category: "श्रेणी",
    subject: "विषय",
    description: "विवरण",
    location: "जगह",
    newAssessment: "नया आकलन",
    newDemand: "मांग जारी करो",
    collectTax: "कर वसूली",
    issueCertificate: "परमान-पत्र जारी करो",
    panchayat: "पंचायत",
    district: "ज़िला",
    block: "खंड",
    ward: "वार्ड",
    owner: "मालिक",
    propertyNo: "जायदाद नं.",
    assessmentNo: "आकलन नं.",
    address: "पता",
    propertyType: "जायदाद किस्म",
    residential: "घर",
    commercial: "धंधा",
    industrial: "कारखाना",
    mixed: "मिला",
    builtArea: "बना क्षेत्र (वर्ग फुट)",
    annualRentalValue: "सालाना किराया मूल्य (₹)",
    houseTax: "गृह कर",
    waterTax: "पानी कर",
    streetLightTax: "बत्ती कर",
    conservancyTax: "सफाई कर",
    drainageTax: "नाली कर",
    totalAmount: "कुल राशि",
    paidAmount: "भरी राशि",
    paymentMode: "भुगतान तरीका",
    cash: "नकद",
    upi: "यूपीआई",
    cheque: "चेक",
    card: "कार्ड",
    online: "ऑनलाइन",
    receipt: "रसीद",
    receiptNo: "रसीद नं.",
    paidAt: "भुगतान तारीख",
    financialYear: "वित्त वर्ष",
    issueDate: "जारी तारीख",
    certificateNo: "परमान-पत्र नं.",
    childName: "बालक का नांव",
    dob: "जन्म तारीख",
    gender: "लिंग",
    fatherName: "पिता का नांव",
    motherName: "माता का नांव",
    placeOfBirth: "जन्म जगह",
    deceasedName: "मरण वाले का नांव",
    dod: "मरण तारीख",
    age: "मरण पर उमर",
    placeOfDeath: "मरण जगह",
    husbandName: "पति का नांव",
    wifeName: "पत्नी का नांव",
    marriageDate: "ब्याह तारीख",
    placeOfMarriage: "ब्याह जगह",
    open: "खुली",
    closed: "बंद",
    in_progress: "चालू",
    sla: "SLA",
    days: "दिन",
    actions: "क्रिया",
    view: "देखो",
    pay: "भरो",
    pending: "लंबित",
    partial: "अधूरा",
    paid: "भरा",
    pickPanchayat: "पंचायत चुनो",
    population: "जनसंख्या",
    households: "घर",
    sarpanch: "सरपंच",
    secretary: "सचिव",
    male: "मरद",
    female: "बीरबानी",
    other: "और",
    digitalSignature: "विकास अर पंचायत विभाग, हरियाणा सूं डिजिटल हस्ताक्षरित",
    approvals: "मंजूरी",
    gisMap: "जीआईएस मानचित्र",
    reports: "रिपोर्ट",
    cashBook: "रोकड़ बही",
    pendingApproval: "मंजूरी लंबित",
    aadhaarVerify: "आधार सत्यापन (डेमो)",
    aadhaarLast4: "आधार के पाछले 4 अंक",
    enterOtp: "ओटीपी डालो",
    sendOtp: "ओटीपी भेजो",
    verify: "सत्यापित करो",
    digiLocker: "डिजिलॉकर सूं लो (डेमो)",
    pppLookup: "पीपीपी परिवार खोज (डेमो)",
    downloadPdf: "पीडीएफ डाउनलोड",
    amount: "राशि",
    taxEngine: "कर इंजन",
    gramSabha: "गाम सभा",
    planning: "जीपीडीपी योजना",
    assetMgmt: "संपत्ति प्रबंधन",
    stakeholders: "ठेकेदार / विक्रेता",
    accounting: "लेखा",
    audit: "लेखा परीक्षा",
  },
};

export const formatINR = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);
